import type * as BasketUpdated from '@ori-events/basket-updated';
import type * as RemoveBasketItem from '@ori-events/remove-basket-item';
import type { PositionData } from '@ori/analytics-data';

import { convertToCamelCase, getHttpRequestSettings } from '../helpers';
import { RequestMethod, RequestUrl } from '../models';

interface Data extends RemoveBasketItem.Data, PositionData {}

export default async ({ detail: { lineNumber, placement } }: CustomEvent<Data>) => {
  const request = await fetch(
    RequestUrl.RemoveBasketItem,
    getHttpRequestSettings({ lineNumber, placement }, RequestMethod.Post),
  );

  return convertToCamelCase<BasketUpdated.Data>((await request.json()) as object);
};
